import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { Box } from "@mui/material";
import { useQuery } from "@tanstack/react-query";

import LogsHistoryTable from "../../../../components/ui/LogsHistoryTable";
import { APIAgentActivityLog } from "../../../../api";
import { useAgentsLogsHistoryContext } from "../../../../context";
import { ISortBy } from "../../../../types";
import { agentsLogsActivityActions } from "../../../../reducers/agentsLogsActivity";
import { AGENT_ACTIVITY_LOG_API_URLS } from "../../../../api/agentActivityLog";

const AgentLogsHistoryTable = (): React.ReactElement => {
  const dispatch = useDispatch();
  const { id }: { id: string } = useParams();

  const [sortBy, setSortBy] = useState<ISortBy>({
    by: "log_time",
    order: false,
  });
  const {
    loading,
    data: { count, logs },
  } = useSelector((state) => state.agentsLogsActivityReducer);
  const { limit, page, setPage, setLimit, activeFilters, setActiveFilters } =
    useAgentsLogsHistoryContext();

  const { isError, error } = useQuery({
    queryKey: [
      AGENT_ACTIVITY_LOG_API_URLS.getAgentActivityLog,
      limit,
      page,
      sortBy,
      id,
      activeFilters,
    ],
    queryFn: async ({ signal }) => {
      dispatch(agentsLogsActivityActions.fetchLogsRequest());
      const response = await APIAgentActivityLog.getActivityLogsRequest(
        {
          limit,
          page,
          sortBy,
          activeFilters,
        },
        signal
      );
      dispatch(agentsLogsActivityActions.fetchLogsSuccess(response.data));
    },
  });

  useEffect(() => {
    console.error("Error fetching agents activity logs", error);
    dispatch(agentsLogsActivityActions.fetchLogsFailed());
  }, [isError, error]);

  return (
    <Box>
      <LogsHistoryTable
        logs={logs}
        loading={loading}
        count={count}
        pagination={{ limit, setLimit, count, page, setPage }}
        handleSort={[sortBy, setSortBy]}
        setActiveFilters={setActiveFilters}
        filterOptions={[
          { key: "admin", label: "Agent" },
          { key: "code", label: "Code" },
          { key: "customer", label: "Customer" },
          { key: "log_time", label: "Date", type: "date" },
        ]}
      />
    </Box>
  );
};

export default AgentLogsHistoryTable;
